import { gql } from '@apollo/client';

export const CoursesQuery = gql`
  query PaginatedCourses($query: String, $first: Int, $after: String) {
    allCourses(query: $query, first: $first, after: $after) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          name
          educationForm
          category {
            name
          }
        }
      }
    }
  }
`;

export const GetCoursesForOptionsQuery = gql`
  query GetCoursesForOptions($agreementDate: Date!) {
    allCourses {
      edges {
        node {
          id
          name
          groups(hideCompleted: $agreementDate) {
            edges {
              node {
                id
                name
                price
                currency
              }
            }
          }
        }
      }
    }
  }
`;

export const GetCoursesForTeacherQuery = gql`
  query GetCoursesForTeacher($first: Int, $query: String) {
    allCourses(first: $first, query: $query) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const GetCourseDataForGroupQuery = gql`
  query getCourseDataForGroup($id: ID!) {
    course(courseId: $id) {
      id
      name
      price
      currency
      teachers {
        edges {
          node {
            id
            fullName
          }
        }
      }
      modules {
        id
        name
        lessons {
          edges {
            node {
              id
              index
              name
              lmsDescription
              taskTypes
              teacherAttachments {
                edges {
                  node {
                    id
                  }
                }
              }
              studentAttachments {
                edges {
                  node {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GetCourseDataForApplicationQuery = gql`
  query getCourseDataForApplication($id: ID!, $groupsDate: Date!) {
    course(courseId: $id) {
      groups(hideCompleted: $groupsDate) {
        edges {
          node {
            id
            name
            freeLessonsCount
          }
        }
      }
    }
  }
`;

/**
 * #132 — цены курса по тарифам (`CoursePlanPrice`): эта сумма подставляется
 * в новый договор с этим тарифом вместо прайса группы.
 *
 * Имя операции ≠ имя поля (`coursePlanPrices`): иначе codegen склеил бы тип
 * результата с типом поля.
 */
export const CourseTariffPricesQuery = gql`
  query CourseTariffPrices($courseId: ID!) {
    coursePlanPrices(courseId: $courseId) {
      id
      courseId
      planId
      planName
      planIsActive
      currency
      amount
    }
  }
`;

/**
 * #132 — имя курса для заголовка карточки. Заголовок раньше брался из
 * `careerCourseSkillSummary` (`CAREER_ROLES`), а карточку теперь открывают и
 * продажи с финансистом — им та сводка отвечает отказом. `course` читают все
 * роли входа в ERP.
 */
export const CourseCardNameQuery = gql`
  query CourseCardName($id: ID!) {
    course(courseId: $id) {
      id
      name
    }
  }
`;
